module.exports = __webpack_public_path__ + "img/vc.776066d2.svg";